import { render, staticRenderFns } from "./ct-addspec.vue?vue&type=template&id=0141ee84&scoped=true"
import script from "./ct-addspec.vue?vue&type=script&lang=js"
export * from "./ct-addspec.vue?vue&type=script&lang=js"
import style0 from "./ct-addspec.vue?vue&type=style&index=0&id=0141ee84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141ee84",
  null
  
)

export default component.exports